module.exports = __webpack_public_path__ + "img/hr-level2addon_idle_gun.d9782142.png";